<template>
    <!-- <div >
        <iv-icon type="ios-folder-outline" size="50"></iv-icon>
    </div> -->
  <section class="empty-page" :style="styles">
      <div class="empty-page__inner">
          <iv-icon :type="icon" size="50"></iv-icon>
          <p>{{ message }}</p>
          <slot name="emptyBtn"/>
      </div>
  </section>
</template>
<script>
export default {
  props: {
    message: {
      type: String,
      default: "暂无数据"
    },
    icon: {
      type: String,
      default: "ios-folder-outline"
    },
    minHeight: {
      type: [Number,String],
      default: 600
    }
  },
  computed: {
    styles(){
      return {
        minHeight: [typeof this.minHeight == 'number', `${this.minHeight}`.indexOf("px")==-1].some(i=>!!i) ? `${this.minHeight}px` : this.minHeight
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.empty-page{
    min-height: 600px;
    display: flex;
    justify-content: center;
    align-items: center;
    .ivu-icon{
        vertical-align: top;
        color: #888888;
    }
    &__inner{
        // border: solid 1px #ddd;
        text-align: center;
        padding: 2em;
        > h1{
            font-size: 32px;
            line-height: 1;
            margin-bottom: 1rem;
        }
        > p{
            font-size: 18px;
            color: #888888;
        }
    }
}
</style>
